/**
 * Converts a File object to a base64-encoded string (without data URL prefix).
 *
 * Centralized helper so different modules can share the same FileReader logic.
 *
 * @param file - File to be converted.
 * @returns Promise resolving to a base64 string (without data URL prefix).
 */
export const fileToBase64 = (file: File): Promise<string> =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = String(reader.result);
      const [, base64] = result.split(',');
      resolve(base64 ?? result);
    };
    reader.onerror = (error) =>
      reject(error ?? new Error('Error reading file'));
  });
